import http from './http'

const basePath = '/achievement/teachingResearchProject'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function saveTeachingProject(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitTeachingProject(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function updateTeachingProject(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  const res = await http.put(basePath, body)
  return res.data
}

export async function getTeachingProject(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function listTeachingProjects(params) {
  const res = await http.get(basePath, { params })
  return res.data
}

export async function deleteTeachingProject(id) {
  const res = await http.delete(withId(id))
  return res.data
}
